module.exports = __webpack_public_path__ + "img/defaultBg.ebcb2176.png";